function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from 'react';
import makeCancellable from 'make-cancellable-promise';
import invariant from 'tiny-invariant';
import warning from 'warning';
import StructTreeItem from "./StructTreeItem.js";
import usePageContext from "./shared/hooks/usePageContext.js";
import useResolver from "./shared/hooks/useResolver.js";
import { cancelRunningTask } from "./shared/utils.js";
export default function StructTree() {
  var pageContext = usePageContext();
  invariant(pageContext, 'Unable to find Page context.');
  var onGetStructTreeErrorProps = pageContext.onGetStructTreeError,
    onGetStructTreeSuccessProps = pageContext.onGetStructTreeSuccess;
  var _useResolver = useResolver(),
    _useResolver2 = _slicedToArray(_useResolver, 2),
    structTreeState = _useResolver2[0],
    structTreeDispatch = _useResolver2[1];
  var structTree = structTreeState.value,
    structTreeError = structTreeState.error;
  var customTextRenderer = pageContext.customTextRenderer,
    page = pageContext.page;
  function onLoadSuccess() {
    if (!structTree) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    if (onGetStructTreeSuccessProps) {
      onGetStructTreeSuccessProps(structTree);
    }
  }
  function onLoadError() {
    if (!structTreeError) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    warning(false, structTreeError.toString());
    if (onGetStructTreeErrorProps) {
      onGetStructTreeErrorProps(structTreeError);
    }
  }
  function resetAnnotations() {
    structTreeDispatch({
      type: 'RESET'
    });
  }
  useEffect(resetAnnotations, [structTreeDispatch, page]);
  function loadStructTree() {
    if (customTextRenderer) {
      // TODO: Document why this is necessary
      return;
    }
    if (!page) {
      return;
    }
    var cancellable = makeCancellable(page.getStructTree());
    var runningTask = cancellable;
    cancellable.promise.then(function (nextStructTree) {
      structTreeDispatch({
        type: 'RESOLVE',
        value: nextStructTree
      });
    }).catch(function (error) {
      structTreeDispatch({
        type: 'REJECT',
        error: error
      });
    });
    return function () {
      return cancelRunningTask(runningTask);
    };
  }
  useEffect(loadStructTree, [customTextRenderer, page, structTreeDispatch]);
  useEffect(function () {
    if (structTree === undefined) {
      return;
    }
    if (structTree === false) {
      onLoadError();
      return;
    }
    onLoadSuccess();
  },
  // Ommitted callbacks so they are not called every time they change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [structTree]);
  if (!structTree) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StructTreeItem, {
    className: "react-pdf__Page__structTree structTree",
    node: structTree
  });
}